import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import TextInput from "./TextInput";

function AddingCrackersImage() {

    const [agentNo, setAgentNo] = useState('');
    const [crackersId, setCrackersId] = useState('');
    const [imageType, setImageType] = useState('');
    const [isDefault, setIsDefault] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const clear = () => {
        setIsDefault(false);
        setSelectedFile(null);
    }

    const defaultStatusChange = () => {
        setIsDefault(!isDefault);
    }

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    }

    const addImage = async (e) => {
        e.preventDefault();
        if (!selectedFile) {
            alert("Please select a file");
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("video_link", imageType);
        formData.append("is_default", isDefault);
        try {
            const response = await fetch(`/v1/admin/agents/${agentNo}/crackers/${crackersId}/resources`, {
                method: "POST",
                body: formData,
            });
            clear();
        } catch (error) {
            console.error("Error uploading file:", error);
        }
    }

    return (
        <>
            <Row>
                <Col lg={4}></Col>
                <Col lg={2}>
                    <TextInput caption={"Agent Mob Number"}
                        value={agentNo}
                        onChange={setAgentNo}
                        validation={{}}
                        info={""}
                        onFocusCaption={"Agent Mob Number"}
                        validator={null}
                        isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Crackers Id"}
                        value={crackersId}
                        onChange={setCrackersId}
                        validation={{}}
                        info={""}
                        onFocusCaption={"Crackers Id"}
                        validator={null}
                        isMultiLine={false} />
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={4}></Col>
                <Col lg={2}>
                    <TextInput caption={"Image type"}
                        value={imageType}
                        onChange={setImageType}
                        validation={{}}
                        info={""}
                        onFocusCaption={"Image type"}
                        validator={null}
                        isMultiLine={false} />
                </Col>
                <Col lg={2} className="d-flex align-items-center">
                    <Form.Check
                        type="checkbox"
                        id="custom-checkbox"
                        label="Is Default?"
                        checked={isDefault}
                        onChange={defaultStatusChange}
                    />
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={4}></Col>
                <Col lg={2}>
                    <input type="file" onChange={handleFileChange}/>
                </Col>
                <Col lg={2}>
                    <button type="submit" onClick={addImage}>Add Image</button>
                </Col>
                <Col lg={4}></Col>
            </Row>
        </>
    )
}

export default AddingCrackersImage;